import { FilterTable } from "@/features/FilterTable/FilterTable";
import { Field } from "@/features/FilterTable/types";
import { z } from "zod";

export const filterA7OPCVMStrategiesSchema = z.object({
  denomination_fonds_contains: z.string().optional(),
  identifiant_fonds_contains: z.string().optional(),
  devise_de_reporting_contains: z.string().optional(),
  contact_fonds_contains: z.string().optional(),
  contact_afd_contains: z.string().optional(),
});

const fields: Field[] = [
  {
    name: "identifiant_fonds_contains",
    label: "Identifiant du Fonds",
    type: "input",
  },
  {
    name: "devise_de_reporting_contains",
    label: "Devise de Reporting	",
    type: "input",
  },
  {
    name: "denomination_fonds_contains",
    label: `Dénomination du Fonds`,
    type: "input",
  },
  {
    name: "contact_fonds_contains",
    label: `Contact du Fonds`,
    type: "input",
  },
  {
    name: "contact_afd_contains",
    label: `Contact AFD`,
    type: "input",
  },
];

export function FilterA7OPCVMStrategies() {
  return (
    <FilterTable
      schema={filterA7OPCVMStrategiesSchema}
      tableName="a7_opcvm_strategies"
      fields={fields}
      client="a7"
      customBuildPath={() => `a7-opcvm/a7_opcvm_strategies`}
    />
  );
}
